import { Col, Row, Tab } from "react-bootstrap";
import AccountInfo from "./components/AccountInfo";
import ChangePassword from "./components/ChangePassword";
import EmailSetting from "./components/EmailSetting";
import PersonalInfo from "./components/PersonalInfo";
import ProfileOverview from "./components/ProfileOverview";
import UserInfo from "./components/UserInfo";
import EmailVerification from "./components/EmailVerification";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useLocation } from "react-router-dom";

const AccountProfile = () => {
    const { user, setUser } = useContext(AuthContext);
    const location = useLocation();

    const getDefaultActiveKey = () => {
        switch (location.pathname) {
            case '/profile-overview':
                return 'ProfileOverview';
            case '/personal-info':
                return 'PersonalInfo';
            case '/change-password':
                return 'ChangePassword';
            default:
                return 'ProfileOverview';
        }
    };


    return (
        <>
            <Row>
                <Col sm={12}>
                    {/* <EmailVerificat ion /> */}
                    <Tab.Container defaultActiveKey={getDefaultActiveKey()} id="user-set-tab">
                        <Row>
                            <UserInfo user={user!} />
                            <Col lg={7} xxl={9}>
                                <Tab.Content id="user-set-tabContent">
                                    <ProfileOverview user={user!} />
                                    <PersonalInfo user={user!} setUser={setUser} />
                                    <ChangePassword />
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                    <div />
                </Col>
            </Row >
        </>
    )

}

export default AccountProfile;